import { render } from "./FeedbackComponent.vue?vue&type=template&id=7bd5fd11"
import script from "./FeedbackComponent.vue?vue&type=script&defer=true&lang=js"
export * from "./FeedbackComponent.vue?vue&type=script&defer=true&lang=js"

import exportComponent from "D:\\FreedomLk\\legal-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__